import { ToggleSwitchDesignTokens } from '@primeuix/themes/types/toggleswitch';

export const ezToggleSwitchThemeConfig: ToggleSwitchDesignTokens = {
  colorScheme: {
    light: {
      root: {
        checkedBackground: '#167007',
        checkedBorderColor: '#167007',
        checkedHoverBackground: '#1C850A',
      },
      handle: {
        checkedColor: '#167007',
      },
    },
  },
};
